export function downloadBlob(blob: Blob, filename: string) {
  // NOTE: This approach won't work well for very large files. For those, we
  // need to find a better way of sending the data to the server and having it
  // generate the file server-side.

  // For better cross-browser compat, consider using:
  // https://github.com/rndme/download
  const url = window.URL.createObjectURL(blob);
  downloadUrl(url, filename);
  window.URL.revokeObjectURL(url); // Revoke the object URL to free up memory
}

export function downloadFile(file: File) {
  downloadBlob(file, file.name);
}

export function downloadUrl(url: string, filename?: string) {
  const a = document.createElement('a');
  a.href = url;
  if (filename) {
    a.download = filename;
  }
  a.style.visibility = 'hidden';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  // Revoke the object URL if it was created
  if (url.startsWith('blob:')) {
    window.URL.revokeObjectURL(url);
  }
}
